import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MAT_DATE_LOCALE} from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-edit-payment-dialog',
  templateUrl: './member-edit-payment-dialog.component.html',
  styleUrls: [ './member-edit-payment-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class MemberEditPaymentDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;   // store User Form
  public order: any;

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberEditPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.order = this.data.order
  }

  ngOnInit () {
    this.entityForm = this.createForm()
  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(this.order.id, [ Validators.required ]),
      rawValue: new FormControl(this.order.rawValue, [ Validators.required ]),
      value: new FormControl(this.order.value, [ Validators.required ]),
      total: new FormControl(this.order.total, [ Validators.required ]),
      discount: new FormControl(this.order.discount, [ Validators.required ]),
      total_minus_tax: new FormControl(this.order.total_minus_tax, [ Validators.required ])
    });
    return form
  }

}
